import { createContext } from 'react';
// Two single-value contexts (one value per provider) so a Button re-renders only
// when the value it consumes changes. `undefined`/`false` defaults mean a standalone
// Button — outside any group — keeps its normal behavior.
export const ButtonGroupSizeContext = /*#__PURE__*/createContext(undefined);
export const ButtonGroupDisabledContext = /*#__PURE__*/createContext(false);